import { Subscribe } from 'unstated';

import DynamicTable from '~/components/DynamicTable/DynamicTable';
import InfiniteLoader from '~/components/InfiniteLoader';
import FormsContainer from '~/containers/Forms';

import ListResponseRow from './ListResponseRow';
import styles from './ListResponses.style';

const ROW_HEIGHT = 58;

class ListResponses extends React.Component {
  state = {
    settingsPopup: false,
    chooseColumnDialog: false,
    columns: [],
    allColumns: [],
  };

  renderRow = (response) => {
    const { columns, classes, onShowResponse } = this.props;

    return (
      <ListResponseRow
        response={response}
        classes={classes}
        columns={columns}
        onClick={(response) => onShowResponse(response)}
      />
    );
  };

  render() {
    const { classes, columns, columnMappings } = this.props;

    return (
      <Subscribe to={[FormsContainer]}>
        {(container) => (
          <div className={classes.root}>
            <DynamicTable columns={columns} columnMapping={columnMappings}>
              <InfiniteLoader
                loadMoreRows={container.loadMoreRows}
                rowRenderer={this.renderRow}
                rowHeight={ROW_HEIGHT}
                total={container.state.total}
                hash={container.getHash(columns)}
              />
            </DynamicTable>
          </div>
        )}
      </Subscribe>
    );
  }
}

ListResponses.propTypes = {
  form: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onShowResponse: PropTypes.func.isRequired,
};

export default withStyles(styles)(ListResponses);
